import React from "react";
import mergeClasses from "../../../../utils/merge-classes.ts";
import {useProjectHeadingContext} from "../../context/project-heading/use-project-heading-context.ts";

const ProjectFormHeading: React.FC = () => {
    const { heading } = useProjectHeadingContext();

    const hasAnyContent = Boolean(heading.left || heading.title || heading.right);
    const padded = heading.padded ?? hasAnyContent;

    return (
        <div className={mergeClasses("flex flex-row items-center", padded && "px-2 py-1")}>
            <div className='flex flex-row gap-x-2 justify-self-start'>
                <div>{heading.left}</div>
                {heading.left && <div className='border-s border-gray-200' />}
                <div>{heading.title}</div>
            </div>
            <div className='justify-self-end'>{heading.right}</div>
        </div>
    );
};

export default ProjectFormHeading;